import { useEffect, useState } from "react";
export const useGameStates = (st: any) => {
  const [canGamble, setCanGamble] = useState<boolean>(false);
  const [showGamble, setShowGamble] = useState<boolean>(false);
  const [gameIsOn, setGameIsOn] = useState<boolean>(false);
  const [showGambleResult, setShowGambleResult] = useState<boolean>(false);
  const [isClickable, setIsClickable] = useState<boolean>(true);
  //  need better solution for states

  const { state, doubleupcard } = st;

  useEffect(() => {
    switch (state) {
      case 1:
        setGameIsOn(false);
        break;
      case 2:
        setIsClickable(false);
        setGameIsOn(true);
        break;
      case 3:
        setCanGamble(true);
        setGameIsOn(true);
        break;
      case 4:
        setShowGamble(true);
        setShowGambleResult(true);
        setGameIsOn(true);
        break;
      case 5:
      case 7:
        if (canGamble) {
          setShowGambleResult(true);
          setCanGamble(false);
          setTimeout(() => {
            setShowGamble(false);
            setShowGambleResult(false);
          }, 800);
        } else {
          setTimeout(() => {
            setCanGamble(false);
            setShowGamble(false);
          }, 500);
        }
        setIsClickable(true);
        setGameIsOn(false);
        break;
      default:
        break;
    }
  }, [
    state,
    doubleupcard,
    canGamble,
    setCanGamble,
    setIsClickable,
    setShowGamble,
    setGameIsOn,
    showGambleResult,
  ]);

  return { canGamble, showGamble, isClickable, showGambleResult, gameIsOn };
};
